import * as THREE from "three";
import { WallType } from "../types/floorplannerTypes";
import { getQuadraticBezierPoint } from "./arcUtils";

const ARC_HIT_TEST_SEGMENTS = 32;

const closestPointOnSegment = (
  point: THREE.Vector2,
  start: THREE.Vector2,
  end: THREE.Vector2,
): THREE.Vector2 => {
  const segment = end.clone().sub(start);
  const lengthSq = segment.lengthSq();
  if (lengthSq <= 1e-12) {
    return start.clone();
  }

  const t = THREE.MathUtils.clamp(point.clone().sub(start).dot(segment) / lengthSq, 0, 1);
  return start.clone().addScaledVector(segment, t);
};

const distanceToSegment = (
  point: THREE.Vector2,
  start: THREE.Vector2,
  end: THREE.Vector2,
): number => point.distanceTo(closestPointOnSegment(point, start, end));

export const isPointOnWallInteractionArea = (
  point: THREE.Vector2,
  wall: WallType,
  defaultWallWidth: number,
  tolerance = 0.02,
): boolean => {
  const wallWidth = wall.wallWidth ?? defaultWallWidth;
  const hitRadius = Math.max(wallWidth / 2, 0) + tolerance;

  if (wall.lineForm === "arc" && wall.controlPoint) {
    let previousPoint = wall.start;
    for (let i = 1; i <= ARC_HIT_TEST_SEGMENTS; i += 1) {
      const t = i / ARC_HIT_TEST_SEGMENTS;
      const nextPoint = getQuadraticBezierPoint(t, wall.start, wall.controlPoint!, wall.end);
      if (distanceToSegment(point, previousPoint, nextPoint) <= hitRadius) {
        return true;
      }
      previousPoint = nextPoint;
    }
    return false;
  }

  return distanceToSegment(point, wall.start, wall.end) <= hitRadius;
};

